import { render, staticRenderFns } from "./EndDotsForm.vue?vue&type=template&id=7b358bf2"
import script from "./EndDotsForm.vue?vue&type=script&lang=js"
export * from "./EndDotsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports